import { render, staticRenderFns } from "./UserNavDropdown.vue?vue&type=template&id=67719c72&scoped=true&"
import script from "./UserNavDropdown.vue?vue&type=script&lang=js&"
export * from "./UserNavDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UserNavDropdown.vue?vue&type=style&index=0&id=67719c72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67719c72",
  null
  
)

export default component.exports